module.exports = __webpack_public_path__ + "img/dimming-light.0ecaedd8.svg";